import moment from "moment";

export interface Row {
	originalDateStartsUTC: string;
	originalDateEndsJustBeforeUTC: string;
}

export function convertMeetingRescheduleRequestDatesToJavascriptDates<
	T extends Row
>(row: T) {
	const { originalDateStartsUTC, originalDateEndsJustBeforeUTC, ...rest } = row;

	return {
		...rest,
		originalDateStartsUTC: moment.utc(originalDateStartsUTC).toDate(),
		originalDateEndsJustBeforeUTC: moment
			.utc(originalDateEndsJustBeforeUTC)
			.toDate()
	};
}
